const exactMessages: Record<string, string> = {
  "email already taken": "El correo ya está en uso",
  "username already taken": "El usuario ya existe",
  "email or username are already taken": "El usuario o el correo ya existen",
  "this attribute must be unique": "El usuario o el correo ya existen",
  forbidden: "No tienes permiso para realizar esta acción",
};

const getRawApiError = (error: any): string => {
  const data = error?.response?.data || error?.data || error;
  const details = data?.error?.details?.errors || [];
  const detailText = details
    .map((item: any) => item?.message)
    .filter(Boolean)
    .join(" ");

  const raw =
    data?.error?.message ||
    data?.message ||
    error?.error?.message ||
    error?.message ||
    "";

  return `${raw} ${detailText}`.trim();
};

export const getApiErrorMessage = (error: any): string => {
  const status = error?.response?.status || error?.status || error?.statusCode;
  if (status === 403) {
    return "No tienes permiso para realizar esta acción";
  }

  const raw = getRawApiError(error);
  const text = raw.toLowerCase();
  const exact = exactMessages[text];
  if (exact) {
    return exact;
  }

  const mentionsEmail = text.includes("email") || text.includes("correo");
  const mentionsUsername =
    text.includes("username") || text.includes("usuario");
  const alreadyTaken =
    text.includes("taken") ||
    text.includes("already") ||
    text.includes("exist") ||
    text.includes("unique") ||
    text.includes("must be unique");

  if (mentionsEmail && mentionsUsername && alreadyTaken) {
    return "El usuario o el correo ya existen";
  }
  if (mentionsEmail && alreadyTaken) {
    return "El correo ya está en uso";
  }
  if (mentionsUsername && alreadyTaken) {
    return "El usuario ya existe";
  }
  if (text.includes("password") && text.includes("short")) {
    return "La contraseña es demasiado corta";
  }

  if (text.includes("request failed with status code")) {
    return "No se pudo completar la operación";
  }

  return raw || "No se pudo completar la operación";
};
